export const AUTH_TOKEN = "Scadenziario\\AuthToken";
